import React from 'react';
import "../styles/pages/home.scss";
import Header from "../../User/layouts/Header";
import { Typography, Container,} from '@mui/material';
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';

const Termsconditions = () => {
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>Terms & Conditions</Typography>
            </section>
            <section className='faq'>
                <Container maxWidth="xl">
                    <div className='terms-content'>
                        <Typography variant='h5'>Last Updated: 03-11-2025</Typography>
                        <Typography variant='h6'>
                            Welcome to Tailors4U, operated by ARYADITYA FASHIONS PRIVATE LIMITED (“Company”, “we”, “us”, “Tailors4U”).
                            These Terms & Conditions (“Terms”, “Agreement”) govern your access to and use of our website <a href='https://www.Tailors4U.com/' target="_blank" rel="noopener noreferrer">https://www.Tailors4U.com/</a>, our mobile application,
                            and other online and offline services related to custom tailoring, design, stitching, and delivery (“Services”).
                        </Typography>
                        <Typography>By accessing, using, or registering on our platform, you agree to be bound by these Terms. If you do not agree, please do not access or use our Services.</Typography>
                    </div>
                    <div className="privacy-content-1">
                        <Typography variant="h5">1. ELIGIBILITY</Typography>
                        <Typography>
                            You must be at least 18 years of age or the legal age of majority in your jurisdiction to use our Services.
                            By registering or using Tailors4U, you represent that:
                            <ul>
                                <li>You are competent to contract under the Indian Contract Act, 1872.</li>
                                <li>The information you provide is true, accurate, and complete.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">2. ACCOUNT REGISTRATION</Typography>
                        <Typography>
                            To use certain features, you must create an account. You agree to:
                            <ul>
                                <li>Provide accurate, current, and complete information during registration.</li>
                                <li>Maintain and promptly update your account information.</li>
                                <li>Keep your login credentials confidential and not share them with anyone.</li>
                                <li>Accept full responsibility for all activities under your account.</li>
                            </ul>

                        </Typography>
                        {/* <Typography>
                            Tailors4U is not liable for any loss or damage arising from unauthorized use of your account.
                        </Typography> */}
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">3. SERVICES</Typography>
                        <Typography>
                            Tailors4U provides online tailoring and design services, including:
                            <ul>
                                <li>Custom stitching and alteration of garments.</li>
                                <li>Pick-up and delivery of orders through authorized delivery partners.</li>
                                <li>Design consultation through our platform or in person.</li>
                            </ul>
                            We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">4. ORDER PLACEMENT AND ACCEPTANCE</Typography>
                        <Typography>
                            <ul>
                                <li>All orders placed through Tailors4U are subject to acceptance and availability.</li>
                                <li>Upon placing an order, you will receive an acknowledgment via email or SMS; however, confirmation of order
                                    acceptance occurs only after we verify measurements, availability, and payment.</li>
                                <li>We reserve the right to reject or cancel any order due to inaccuracies, unavailability, or other valid reasons.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">5. PRICING AND PAYMENT</Typography>
                        <Typography>
                            <ul>
                                <li>All prices listed are in <strong styles={{}}>Indian Rupees (INR)</strong>  and are Exclusive of applicable taxes unless stated otherwise.</li>
                                <li>Payment can be made via <strong styles={{}}> credit/debit cards, UPI, net banking</strong>, or other approved payment methods.</li>
                                <li>Tailors4U uses <strong styles={{}}>secure payment gateways</strong>  and does not store your payment card information.</li>
                                <li>You agree to use only payment methods lawfully owned by you.</li>
                                {/* <li>Tailors4U shall not be responsible for any unauthorized or fraudulent transactions.</li> */}
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">6. ALTERATION POLICY</Typography>
                        <Typography>
                            <ul>
                                <li>If the delivered garment does not fit, you can <strong styles={{}}>raise an alteration request within 3 days</strong> of delivery via the app or website.</li>
                                <li>Our designer may visit for home alteration or arrange pickup, alteration, and delivery depending on the case.</li>
                                <li>The decision of the Tailors4U team regarding feasibility and scope of alterations is <strong styles={{}}>final and binding.</strong></li>
                                <li>Alterations to the <strong styles={{}}>original design or customization requests</strong> beyond fit adjustments are not covered.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">7. CANCELLATION AND REFUND POLICY</Typography>
                        <Typography>
                            <ul>
                                <li>Orders once processed cannot be cancelled as each garment is custom-made.</li>
                                <li>Refunds are not applicable after the stitching process begins.</li>
                                <li>If Tailors4U cancels your order due to unforeseen reasons, a full refund will be initiated to the original payment method within 7–10 business days.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">8. DELIVERY POLICY</Typography>
                        <Typography>
                            <ul>
                                <li>We strive to deliver orders within the estimated timeline communicated during booking.</li>
                                <li>Delays may occur due to unforeseen factors (e.g., weather, logistics, or technical issues).</li>
                                <li>Tailors4U is not liable for delays caused by third-party delivery services.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">9. INTELLECTUAL PROPERTY</Typography>
                        <Typography>
                            All content on Tailors4U, including designs, graphics, logos, and software, are the property of <strong styles={{}}>ARYADITYA FASHIONS PRIVATE LIMITED</strong>.
                        </Typography>
                        <Typography>You may not copy, modify, reproduce, or distribute any part of our platform without prior written consent.</Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">10. USER RESPONSIBILITIES</Typography>
                        <Typography>
                            By using our Services, you agree not to:
                            <ul>
                                <li>Engage in fraudulent, misleading, or unlawful activities.</li>
                                <li>Upload or transmit any harmful or offensive material.</li>
                                <li>Misuse or disrupt the functioning of the platform.</li>
                                <li>Infringe upon our or others’ intellectual property rights.</li>
                            </ul>
                            Tailors4U reserves the right to suspend or terminate your account for any violation of these Terms.
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">11. PRIVACY</Typography>
                        <Typography>
                            Your use of our Services is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data.
                        </Typography>
                        <Typography>
                            You can review it at:{" "}
                            <a href="https://www.tailors4u.com/privacypolicy" target="_blank" rel="noopener noreferrer">
                                https://www.tailors4u.com/privacy-policy
                            </a>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">12. LIMITATION OF LIABILITY</Typography>
                        <Typography>
                            To the fullest extent permitted by law:
                            <ul>
                                <li>Tailors4U shall not be liable for any indirect, incidental, or consequential damages arising from your use of our Services.</li>
                                <li>We are not responsible for inaccuracies in measurements or customization details provided by you.</li>
                                <li>Our total liability for any claim shall not exceed the total amount paid for the order in question.</li>
                            </ul>
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">13. INDEMNIFICATION</Typography>
                        <Typography>
                            You agree to indemnify and hold harmless Tailors4U, its employees, affiliates, and partners from any claims, damages, or expenses arising from your breach of these Terms or your use of the Services.
                        </Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">14. THIRD-PARTY LINKS</Typography>
                        <Typography>
                            Our website or app may contain links to third-party websites.
                        </Typography>
                        <Typography>Tailors4U does not control or endorse these websites and is not responsible for their content or policies.</Typography>
                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">15. MODIFICATION OF TERMS</Typography>
                        <Typography>
                            Tailors4U reserves the right to modify these Terms at any time.
                        </Typography>
                        <Typography>Updated versions will be posted on our website, and continued use of our Services after such updates constitutes your acceptance.</Typography>

                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">16. GOVERNING LAW AND JURISDICTION</Typography>
                        <Typography>
                            These Terms are governed by and construed in accordance with the <strong styles={{}}>laws of India</strong>.
                        </Typography>
                        <Typography>Any disputes shall be subject to the <strong >exclusive jurisdiction of the courts of Hyderabad, Telangana</strong>.</Typography>

                    </div>

                    <div className="privacy-content-1">
                        <Typography variant="h5">17. CONTACT US</Typography>
                        <Typography>
                            If you have any questions about these Terms, please contact us: <br />
                            📧<a
                                href="mailto:support@tailors4u.com"
                            > support@tailors4u.com </a><br />
                            🏢 ARYADITYA FASHIONS PRIVATE LIMITED
                        </Typography>
                    </div>

                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Termsconditions;